import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import $ from 'jquery';


export default function NavView_m(props) {

    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {


    }, []);

    function logoTap() {
        window.location.href = window.location.origin;
    }

    return (
        <Stack
            sx={{
                position: 'fixed',
                top: 0,
                zIndex: 100,
                width: 1,
                flexDirection: 'row',
                alignItems: 'center',
                bgcolor: '#000000cc',
                py: 1,
            }}>

            <Box
                onClick={logoTap}
                component={'img'}
                src={JSTool.getImgPath('logo_new.png')}
                sx={{
                    height: '55rem',
                    cursor: 'pointer',
                    ml: 2,
                }} />

            <Box sx={{ flex: 1 }} />

            <Box
                onClick={() => { JSTool.twitterTap() }}
                component={'img'}
                src={JSTool.getImgPath('twitter.png')}
                sx={{
                    height: '45rem',
                    mr: 2,

                }} />

            <Box
                onClick={() => { JSTool.discordTap() }}
                component={'img'}
                src={JSTool.getImgPath('discord.png')}
                sx={{
                    height: '45rem',
                    mr: 2,

                }} />

            <Box
                onClick={() => {
                    if (JSTool.isIOS) {
                        JSTool.appleTap();
                    } else {
                        JSTool.googleTap();
                    }
                }}
                component={'img'}
                src={JSTool.getImgPath(JSTool.isIOS ? 'release_apple.png' : 'release_google.png')}
                sx={{
                    height: '45rem',
                    mr: 2,
                }} />

        </Stack>
    );
}
